import React, {useState , useEffect, useRef, useContext} from 'react'

//Node Modules
import { useTranslation } from 'react-i18next'
import {Alert} from 'react-bootstrap'
import parse from 'html-react-parser'

//Components
import Modal from 'components/Modal'

//Styles
import styles from './SecureModal.module.scss'

//Context
import { ToggleSecureContext } from 'context/content-context'

//Hooks
import { useIsSmallDevice } from 'hooks'

export interface Props {
  show: boolean,
  onHide: () => void,
  submit: (key:string) => Promise<void>
}

const SecureModal = ({show, onHide, submit}:Props) => {
  const { t } = useTranslation()

  const title = t('helpcenter-gui-icu.secure.modal.header.title')

  const openTag =  "<a href='http://support.sas.com/ctx/supportform/createForm'>"
  const closeTag = '</a>'
  const parsedLabel = parse( t("helpcenter-gui-icu.securemodal.body.contact_technical_support", { openTag: openTag, closeTag:closeTag } ) )
  const label = JSON.stringify(parsedLabel).replace(/\"/g, '') /* eslint-disable-line */

  const [accessKey, setAccessKey] = useState<string>('')
  const [showError, setShowError] = useState<boolean>(false)

  const input = useRef<HTMLInputElement>(null)

  const toggleSecureContext = useContext(ToggleSecureContext)

  useEffect(()=>{
    input.current?.focus()
  })

  const submitAccessKey = () => {
    if (submit) submit(accessKey).then( () => {
      toggleSecureContext.toggleSecure()
    }, () => {
      setShowError(true)
    })
  }

  const handleKeypress = (key: string) => {
    if (key === 'Enter') {
      submitAccessKey()
    }
  }

  return (
    <>
      <Modal show={show} title={title} onHide={onHide} onOk={submitAccessKey} onHideText="helpcenter-gui-icu.modal.cancel_button.title" secureModal={true}>
        {showError ? <Alert key='wrongKeyMsg' variant='danger'>{t("helpcenter-gui-icu.securemodal.alert.wrong_key.msg")}</Alert>: null}
        <div className={`${styles.field} ${styles.inputContainer}`}>
          <div><label className={styles.label}>{t("helpcenter-gui-icu.secure.modal.input.label")}</label></div>
          {<input type='password' ref={input} className={styles.input} value={accessKey} onChange={e => setAccessKey(e.target.value)} onKeyPress={e => handleKeypress(e.key)} aria-label={t('helpcenter-gui-icu.securemodal.input.placeholder.aria')}></input>}
        </div>
        <div className={`${styles.field} ${styles.label_nokey}`}>
          {t("helpcenter-gui-icu.securemodal.body.no_key.msg")}
        </div>
        <div className={`${styles.field} ${styles.label_nokey}`}>
          { parse(label) }
        </div>
      </Modal>
    </>
  )
}

export default SecureModal